import {INCOME_TYPE} from '../constants/income';
import {INCOME_MARKER} from '../configs/incomeMarker';
import {SIZE_RECRUITMENT_TEXTURE_KEYS} from '../configs/sizeRecruitmentMarker';
import {INCOME_TEXT_STYLE} from '../styles/HexGrid.style';
import {ensureSizeRecruitmentTextures} from '../utils/effects/sizeRecruitmentTextures';

// Над жетонами, но под отрядами соседних ячеек: ореол выходит за свою ячейку
const HALO_DEPTH = 2.5;
const STROKE_COLOR = '#160b03';
const STROKE_THICKNESS = 8;

/**
 * Плашка дохода (см. configs/incomeMarker). Элементы принадлежат вызывающему:
 * постоянный слой регистрирует их на ячейке, разовая анимация уничтожает сама
 *
 * @param {Phaser.Scene} scene
 * @param {Object} params
 * @param {number} params.x — центр медальона
 * @param {number} params.y
 * @param {number} params.hexSize
 * @param {number|string} params.value — доход
 * @param {string} params.incomeType — INCOME_TYPE
 * @param {boolean} [params.isBlocked] — точка заблокирована противником
 * @param {boolean} [params.hasHalo] — светится ли плашка
 * @param {number} params.depth
 * @param {Object} [params.textStyle] — поправка стиля числа (дробный доход)
 * @param {number} [params.linearFilter] — режим фильтрации LINEAR для текстур
 * @returns {{elements: Object[], halo: Object|null}}
 */
export const createIncomeMarker = (scene, {
  x, y, hexSize, value, incomeType, isBlocked = false, hasHalo = true, depth, textStyle = {}, linearFilter,
}) => {
  ensureSizeRecruitmentTextures(scene, {linearFilter});
  const {plateSizeFactor, textX, textScale, iconX, coinsIconY, iconScale, halo: haloConfig, themes, blocked} = INCOME_MARKER;
  const isCoins = incomeType === INCOME_TYPE.COINS;
  const theme = themes[incomeType] || themes[INCOME_TYPE.COINS];
  const isGlowing = hasHalo && !isBlocked;

  let halo = null;
  if (isGlowing) {
    halo = scene.add.image(x, y, SIZE_RECRUITMENT_TEXTURE_KEYS.HALO);
    halo.setScale((hexSize * haloConfig.sizeFactor) / (halo.width || 1));
    halo.setDepth(HALO_DEPTH);
    halo.setTint(theme.haloTint);
    halo.baseScale = halo.scaleX;
  }

  const plate = scene.add.image(x, y, theme.plateKey);
  plate.setScale((hexSize * plateSizeFactor) / (plate.width || 1));
  plate.setDepth(depth);

  const text = scene.add.text(x + hexSize * textX, y, `${value}`, {
    ...INCOME_TEXT_STYLE,
    ...textStyle,
    color: isBlocked ? blocked.textColor : '#ffffff',
    stroke: STROKE_COLOR,
    strokeThickness: STROKE_THICKNESS,
  });
  text.setScale(textScale);
  text.setOrigin(0.5, 0.5);
  text.setDepth(depth);

  const icon = scene.add.image(
    x + hexSize * iconX,
    y + (isCoins ? hexSize * coinsIconY : 0),
    isCoins ? 'coins_icon' : 'win_points',
  );
  icon.setScale(iconScale);
  icon.setOrigin(0.5, 0.5);
  icon.setDepth(depth);

  if (isBlocked) {
    plate.setTint(blocked.plateTint);
    icon.setTint(blocked.iconTint);
  } else {
    // Золотой или серебряный перелив цифр сверху вниз
    text.setTint(theme.textTintTop, theme.textTintTop, theme.textTintBottom, theme.textTintBottom);
  }

  return {elements: [...(halo ? [halo] : []), plate, text, icon], halo};
};
